import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Page-Last"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-page-last',
    templateUrl: './icon-page-last.component.html',
    styleUrls: ['./icon-page-last.component.scss'],
    standalone: false
})
export class IconPageLastComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
